import Helper from '@ember/component/helper';

type EmberContext = {
  styles: Record<string, string>;
};

export default class Styles extends Helper {
  compute(params: [EmberContext, string]): string {
    const [context, classNames] = params;

    if (typeof context?.styles === 'undefined') {
      console.error('Import and assign your styles to your component class or controller class');
      console.log(classNames, context);
      return '';
    }

    const classString = classNames
      .split(' ')
      .map((name: string): string => {
        if (context?.styles && context?.styles[name]) {
          return <string>context.styles[name];
        }

        console.error(`The class or id named '${name}' does not exist`);

        return '';
      })
      .join(' ');

    return classString;
  }
}
